module.exports = __webpack_public_path__ + "static/media/economic_schedule.7705671b.svg";